import { HomeVisitConclusionType } from "@/@types/esus/HomeVisitConclusionType";
import { esusApi } from "../api";

type GetHomeVisitConclusionTypesParams = {
	uf: string;
	ibgeCode: string;
	cnes: string;
};

export async function getHomeVisitConclusionTypes({
	uf,
	ibgeCode,
	...params
}: GetHomeVisitConclusionTypesParams) {
	const response = await esusApi.get<HomeVisitConclusionType[]>(
		`/uf/${uf}/city/${ibgeCode}/homeVisitConclusionType/GetAll`,
		params
	);
	return response.data || [];
}
